module.exports = __webpack_public_path__ + "img/beer_id-70.82913db4.png";